import React from 'react';
import PropTypes from 'prop-types';
import { ACCEPT, LEARN_MORE } from "../../../utils/default-strings";
import { Modal } from "../../elements/Modal";
import { FlexContainer } from "../../layout/FlexContainer";
import { Button } from "../../elements/Button";
import { Divider } from "../../elements/Divider";
import { HorizontalGutters } from "../../layout/HorizontalGutters";
import { Paragraph } from "../../typography/Paragraph";
import { withResponsive } from "../../../utils/with-responsive";
import { Link } from "../../elements/Link";
import { getFormMarkup } from "./utils/getFormMarkup";

var Component = function Component(_ref) {
  var buttonText = _ref.buttonText,
      isOpen = _ref.isOpen,
      isUserOnMobile = _ref.isUserOnMobile,
      linkText = _ref.linkText,
      linkUrl = _ref.linkUrl,
      onAccept = _ref.onAccept,
      text = _ref.text;
  if (!isOpen) return false;
  return isUserOnMobile ? React.createElement(Modal, {
    hasCloseIcon: false,
    hasRoundedCorners: true,
    isOpen: true
  }, React.createElement(HorizontalGutters, null, React.createElement(FlexContainer, {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center"
  }, React.createElement(Divider, null), React.createElement(Paragraph, null, text), React.createElement(Link, {
    href: linkUrl,
    willOpenInNewTab: true
  }, linkText), React.createElement(Divider, null), React.createElement(Button, {
    isRounded: true,
    onClick: onAccept
  }, buttonText), ' ', React.createElement(Divider, null)))) : React.createElement("div", {
    className: "cookies-form"
  }, getFormMarkup(buttonText, linkText, linkUrl, onAccept, text));
};

Component.displayName = 'CookieAlert';
Component.defaultProps = {
  buttonText: ACCEPT,
  isOpen: false,
  linkText: LEARN_MORE,
  linkUrl: '/'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  buttonText: PropTypes.string,
  isOpen: PropTypes.bool,
  isUserOnMobile: PropTypes.bool.isRequired,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
  onAccept: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
} : {};
export var ComponentWithResponsive = withResponsive(Component);